import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    count: 0,
    user_menu: [],
    toolbar: {},
    propuesta: {},
    user_type: 'L',
    ApiUser_Supplier: '-',
    ApiKey_id: '-',
    ApiUser_id: '-',
    ApiUserType_id: '-',
    MotherSupplier_Desc: '-',
    ApiUser_GivenName: '-',
    ApiUser_EMail: '-',
    closeInd: '',
    tiemout:0
  },
  mutations: {
    increment (state) {
      state.count++
    },
    updateMenu (state, menu) {
      state.user_menu = menu
    },
    updateTitle (state, title) {
        //state.toolbar_title = title
        Vue.set(state.toolbar, 'title', title)
        //state.obj = { ...state.obj, 'toolbar_title': title }
    },
    updateFilterDialog(state, propuesta) {
      state.propuesta = propuesta
    },
    updateUserType(state, user_type) {
      state.user_type = user_type
    },
    updateUser_detail(state,data)
    {
      state.ApiKey_id=data.ApiKey_id
      state.ApiUser_id=data.ApiUser_id
      state.ApiUser_Supplier=data.ApiUser_Supplier
      state.ApiUserType_id=data.ApiUserType_id
      state.MotherSupplier_Desc=data.MotherSupplier_Desc
      state.ApiUser_GivenName=data.displayName
      state.ApiUser_EMail=data.mail
      state.tiemout=data.tiemout
    },
    updateUser_Supplier(state,data)
    {
      state.ApiUser_Supplier=data.ApiUser_Supplier
      state.MotherSupplier_Desc=data.MotherSupplier_Desc
    },
    updateUser_TimeOut(state,data)
    {
      state.tiemout=data.TimeOut_Sg
    },
    updateClose(state, closeInd)
    {
      state.closeInd = closeInd
    }
  },
  actions: {

  }
})


// WEBPACK FOOTER //
// ./src/store/index.js